import React from 'react';
import Layout from "../../components/layout/Layout";
import ChangePasswordForm from "../../components/auth/ChangePasswordForm";
const ChangePasswordPage = () => {
    return (
      <Layout>
          <ChangePasswordForm />
      </Layout>
    );
  }

  export default (ChangePasswordPage);